import getAllOptions from './getAllOptions';
import OptionWithPath from '../store/schema/OptionWithPath';
import { computed, IComputedValue } from 'mobx';

import { getOwaWorkload } from 'owa-workloads';
import {
    OptionQuickComponentSettings,
    OptionQuickComponentSettingsWithKey,
    QuickSettingOrder,
    Option,
    LazyOption,
} from 'owa-options-core';

export interface QuickOptionSettingsProps {
    key: string;
    quickOptionSettings: OptionQuickComponentSettings;
    titleStringKey: string;
    order: QuickSettingOrder;
}

function getQuickOptionProps(option: OptionWithPath) {
    let allQuickOptionsProps: QuickOptionSettingsProps[] = [];
    let quickOptionSettings = getQuickOptionsSettings(option);
    if (quickOptionSettings) {
        if (Array.isArray(quickOptionSettings)) {
            let multipleQuickOptionSettingsWithKey = quickOptionSettings as OptionQuickComponentSettingsWithKey[];
            multipleQuickOptionSettingsWithKey.forEach(function(
                quickOptionSettingWithKey: OptionQuickComponentSettingsWithKey
            ) {
                if (shouldShowQuickOptionSetting(quickOptionSettingWithKey)) {
                    allQuickOptionsProps.push({
                        quickOptionSettings: quickOptionSettingWithKey,
                        order: quickOptionSettingWithKey.getOrder(),
                        titleStringKey: quickOptionSettingWithKey.customTitle
                            ? quickOptionSettingWithKey.customTitle
                            : option.titleStringKey,
                        key: quickOptionSettingWithKey.key,
                    });
                }
            });
        } else {
            if (shouldShowQuickOptionSetting(quickOptionSettings)) {
                const quickOptionsProps = <QuickOptionSettingsProps>{
                    quickOptionSettings: quickOptionSettings,
                    order: quickOptionSettings.getOrder(),
                    titleStringKey: quickOptionSettings.customTitle
                        ? quickOptionSettings.customTitle
                        : option.titleStringKey,
                    key: option.key,
                };

                allQuickOptionsProps.push(quickOptionsProps);
            }
        }
    }

    return allQuickOptionsProps;
}

function shouldShowQuickOptionSetting(
    option: OptionQuickComponentSettings | OptionQuickComponentSettingsWithKey
) {
    return getOwaWorkload() & option.workloads && !(option.isHidden && option.isHidden());
}

let quickOptions = computed(() => {
    let allQuickOptionsProps: QuickOptionSettingsProps[] = [];

    if (
        getAllOptions().some(
            option => hasLazyQuickOption(option) && !option.tryImportQuickOptionSettingsSync()
        )
    ) {
        // Wait for all the lazy quick options to load
        return [];
    }

    getAllOptions().forEach(function(option: OptionWithPath) {
        let quickOptionProps = getQuickOptionProps(option);
        if (quickOptionProps) {
            allQuickOptionsProps = allQuickOptionsProps.concat(quickOptionProps);
        }
    });

    return allQuickOptionsProps.sort((a, b) => a.order - b.order);
}) as IComputedValue<QuickOptionSettingsProps[]>;

function hasLazyQuickOption(option: any): option is LazyOption {
    return !!option.tryImportQuickOptionSettingsSync;
}
function getQuickOptionsSettings(option: OptionWithPath) {
    return hasLazyQuickOption(option)
        ? (option as LazyOption).tryImportQuickOptionSettingsSync()
        : (option as Option).quickOptionSettings;
}

export default () => quickOptions.get();
